<script>
  import { Modal, Tag } from "carbon-components-svelte";
  import { createEventDispatcher } from "svelte";
  import { InlineCalendar } from "svelte-calendar";
  import { Input } from "sveltestrap";

  import dayjs from "dayjs";
  import "dayjs/locale/ko.js";
  import BaseModal from "./BaseModal.svelte";

  export let open;

  const theme = {
    calendar: {
      width: "350px",
      shadow: "0px 0px 5px rgba(0, 0, 0, 0.25)",
    },
    font: {
      regular: "1em",
      large: "37em",
    },
  };

  let store;
  const dispatch = createEventDispatcher();

  function submit() {
    if (selectedDateTimeFormatStr)
      dispatch("submit", { date: selectedDateTimeFormatStr });
  }

  const formatList = [
    "YYYY-MM-DD",
    "YYYY-MM-DD hh:mm",
    "YYYY년MM월DD일",
    "YYYY년MM월DD일 ddd",
    "hh:mm",
    "hh시mm분",
    "a hh시mm분",
  ];
  let selectedIdx = 0;
  let format = formatList[selectedIdx];
  function selectedFormat(i) {
    selectedIdx = i;
    format = formatList[selectedIdx];
  }
  let selectedDate;
  let selectedTime = "00:00";
  let selectedDateTimeFormatStr;
  $: dayjs.locale("ko");
  $: {
    if ($store) {
      let time = selectedTime.split(":");
      selectedDate = new Date(
        $store?.year,
        $store?.month,
        $store?.day,
        time[0],
        time[1]
      );
      selectedDateTimeFormatStr = dayjs(selectedDate).format(format);
    }
  }
  $: selectedTime = dayjs(new Date()).format("hh:mm");
</script>

<BaseModal
  bind:show={open}
  onClose={() => (open = false)}
  title="달력 선택"
  width={463}
  disableOverlayClose={true}
  on:submit={submit}
>
  <div>
    <style>
      .calendar-modal > .bx--modal-container {
        width: 500px;
      }
      .format-wrapper {
        text-align: center;
        padding: 10px 0px;
      }
      .calendar-wrapper {
        text-align: center;
        padding: 10px 0px;
      }
      .time-wrapper {
        text-align: center;
      }
    </style>
    <div class="format-wrapper">
      {#each formatList as format, i}
        <Tag
          type={i === selectedIdx ? "blue" : "gray"}
          on:click={() => selectedFormat(i)}>{format}</Tag
        >
      {/each}
    </div>
    <div class="calendar-wrapper">
      <InlineCalendar bind:store {theme} {format} />
    </div>
    <div class="time-wrapper">
      <Input
        type="time"
        name="time"
        id="exampleTime"
        placeholder="time placeholder"
        bind:value={selectedTime}
      />
    </div>
  </div>
</BaseModal>
<!-- <Modal
    class="calendar-modal"
    bind:open
    modalHeading="달력 선택"
    primaryButtonText="확인"
    on:click:button--secondary={() => (open = false)}
    on:open
    on:close
    on:submit={submit}
>
    <div>
        <style>
            .calendar-modal > .bx--modal-container {
                width: 500px;
            }
            .format-wrapper {
                text-align: center;
                padding: 10px 0px;
            }
            .calendar-wrapper {
                text-align: center;
                padding: 10px 0px;
            }
            .time-wrapper {
                text-align: center;
            }
        </style>
        <div class="format-wrapper">
            {#each formatList as format, i}
                <Tag
                    type={i === selectedIdx ? "blue" : "gray"}
                    on:click={() => selectedFormat(i)}>{format}</Tag
                >
            {/each}
        </div>
        <div class="calendar-wrapper">
            <InlineCalendar bind:store {theme} {format} />
        </div>
        <div class="time-wrapper">
            <Input
                type="time"
                name="time"
                id="exampleTime"
                placeholder="time placeholder"
                bind:value={selectedTime}
            />
        </div>
    </div>
</Modal> -->
